import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TimeSlotV2Cst from "@components/TimeSlotV2Cst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";

const UsageLimitsSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: theme.palette.text.primary,
        }}
      >
        {t("sections.limits.title")}
      </Typography>
      <TimeSlotV2Cst
        initialTimeSlots={data.time_slots}
        onChange={(slots) => setData({ time_slots: slots })}
      />
    </Box>
  );
};

export default UsageLimitsSection;
